import { render } from "./SnsShare.vue?vue&type=template&id=38a4ed7f&scoped=true"
import script from "./SnsShare.vue?vue&type=script&lang=js"
export * from "./SnsShare.vue?vue&type=script&lang=js"

import "./SnsShare.vue?vue&type=style&index=0&id=38a4ed7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a4ed7f"]])

export default __exports__